import axios from 'axios';

// Constants
import { AXIOS_CONSTANTS } from 'CONSTANTS/apiConstants';

// Service
import logger from 'SERVICES/logger';

let getAccessTokenCallback: any;
/**
 *
 * @param {Function} callback: Callback to get access token
 */
export const injectCallbackToGetAccessToken = (callback: any) => {
  if (typeof callback === 'function') {
    getAccessTokenCallback = callback;
  } else {
    logger.error('Please provide callback function to get accessToken');
  }
};

export const getAccessToken = () => getAccessTokenCallback();

export const createAxiosInstance = (baseURL: string | undefined) => {
  return axios.create({
    baseURL,
    headers: {
      Accept: AXIOS_CONSTANTS.REQUEST_HEADERS.CONTENT_TYPE_JSON,
      'Content-Type': AXIOS_CONSTANTS.REQUEST_HEADERS.CONTENT_TYPE_JSON,
    },
    timeout: AXIOS_CONSTANTS.REQUEST_TIMEOUT,
  });
};
